module.exports = __webpack_public_path__ + "img/lsmy-ai-robot.9c447455.png";